import { instance, errorService } from '@/services/api'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import HeaderRenderer from '@/components/DynamicComponents/Renderers/headerRenderer'
import EstimateInfoRenderer from '@/components/DynamicComponents/Renderers/estimateInfoRenderer'
import EstimateMethodRenderer from '@/components/DynamicComponents/Renderers/estimateMethodRenderer'
import Grid from '@/components/DynamicComponents/Projects/EstimateInfo/Grid'

export default {
  props: [
    'url',
    'estimateMethod',
    'residualPercentage',
    'variance',
    'infoType',
  ],
  components: {
    'ag-grid-vue': AgGridVue,
    'estimate-takeoff': Grid,
  },
  data: function() {
    return {
      loading: true,
      gridOptions: null,
      columnDefs: [],
      varianceColumnDefs: [],
      residualColumnDefs: [],
      frameworkComponents: null,
      width: '100%',
      height: '11rem',
      modalWidth: '70rem',
      padding: '0px',
      visible: false,
      domLayout: null,
      estimateMethods: [
        {
          id: 1,
          estimateMethod: 1,
        },
        {
          id: 2,
          estimateMethod: 2,
        },
      ],
      list: [],
    }
  },
  beforeMount() {
    this.visible = true
    if (this.infoType) {
      this.getInfo()
    } else {
      this.loadingConfig()
    }
    window.addEventListener('resize', this.detectViewPortListener)
  },
  created() {
    this.domLayout = 'autoHeight'
  },
  methods: {
    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 50,
        rowHeight: 50,
        suppressRowClickSelection: true,
        singleClickEdit: false,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        suppressContextMenu: true,
        defaultColDef: {
          sortable: false,
          suppressMovable: true,
          resizable: false,
          editable: false,
          filter: false,
          menuTabs: [],
        },
      }
      this.frameworkComponents = {
        toolTipRenderer: ToolTipRenderer,
        headerRenderer: HeaderRenderer,
        estimateInfoRenderer: EstimateInfoRenderer,
        estimateMethodRenderer: EstimateMethodRenderer,
      }
      this.columnDefs = [
        {
          headerName: 'Estimate Method',
          field: 'estimateMethod',
          headerTooltip: 'Estimate Method',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            name: 'estimateMethod',
          },
          width: 150,
          wrapText: false,
          cellRenderer: 'estimateMethodRenderer',
          pinned: 'left',
        },
      ]
    },

    async onLoad(params) {
      this.loading = true
      params.api.sizeColumnsToFit()
      const data = await this.getData()
      const details = this.refreshColumns(data)
      params.api.setColumnDefs(details.columns)
      params.api.sizeColumnsToFit()
      params.api.setRowData(details.data)
      this.loading = false
    },

    async getInfo() {
      this.list = await this.getData()
      this.loading = false
    },

    getData() {
      return instance
        .get(this.url)
        .then(response => {
          return _.get(response.data, 'result', [])
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    refreshColumns(result) {
      let displayColumns = this.columnDefs
      const data = []
      let assetClassObject = {}
      let percentage = {}
      let assetClasses = {}
      result.forEach(element => {
        assetClassObject = {}
        percentage = {}
        assetClasses = {}
        element.forEach(assetClass => {
          const isPresent = displayColumns.some(
            i =>
              i.field === assetClass.assetClass &&
              i.headerComponentParams &&
              i.headerComponentParams.life === assetClass.life,
          )
          if (!isPresent) {
            displayColumns.push({
              field: assetClass.assetClass,
              headerClass: 'header-right',
              cellStyle: { textAlign: 'right' },
              headerComponent: 'headerRenderer',
              headerComponentParams: {
                life: assetClass.life,
              },
              width: 120,
              cellRenderer: 'estimateInfoRenderer',
              life: assetClass.life,
            })
          }
          Object.assign(percentage, {
            [assetClass.assetClass]: assetClass.percentage,
          })
          Object.assign(assetClasses, {
            [assetClass.assetClass]: assetClass.allocatedCost,
          })
          Object.assign(assetClassObject, {
            estimateMethod: assetClass.estimateMethod
              ? assetClass.estimateMethod
              : this.estimateMethod,
            residualPercentage: this.residualPercentage,
            percentage: { ...percentage },
            assetClass: { ...assetClasses },
          })
        })
        assetClassObject = { ...assetClassObject }
        data.push(assetClassObject)
      })
      displayColumns = _.sortBy(displayColumns, ['life'])
      if (!this.infoType) {
        this.modalWidth = 'auto'
        this.padding = '10px !important'
        this.width =
          displayColumns.length === 7
            ? '66rem'
            : displayColumns.length === 6
              ? '56rem'
              : displayColumns.length === 5
                ? '47rem'
                : displayColumns.length === 4
                  ? '40rem'
                  : displayColumns.length === 3
                    ? '30rem'
                    : displayColumns.length === 2
                      ? '22rem'
                      : '100%'
      }
      return { columns: displayColumns, data: data }
    },

    onClose() {
      this.visible = false
      this.$emit('closeEstimateInfo')
    },

    detectViewPortListener() {
      if (window.innerWidth > 1450) {
        if (!this.infoType) {
          this.modalWidth = 'auto'
          this.padding = '10px !important'
          this.width =
            this.columnDefs.length === 7
              ? '66rem'
              : this.columnDefs.length === 6
                ? '56rem'
                : this.columnDefs.length === 5
                  ? '47rem'
                  : this.columnDefs.length === 4
                    ? '40rem'
                    : this.columnDefs.length === 3
                      ? '30rem'
                      : this.columnDefs.length === 2
                        ? '22rem'
                        : '100%'
        } else {
          this.modalWidth = '70rem'
          this.padding = '0px !important'
        }
      } else if (window.innerWidth < 1450) {
        this.modalWidth = '100%'
        this.padding = '10px !important'
        this.width = '100%'
      } else {
        if (!this.infoType) {
          this.modalWidth = 'auto'
          this.padding = '10px !important'
          this.width =
            this.columnDefs.length === 7
              ? '66rem'
              : this.columnDefs.length === 6
                ? '56rem'
                : this.columnDefs.length === 5
                  ? '47rem'
                  : this.columnDefs.length === 4
                    ? '40rem'
                    : this.columnDefs.length === 3
                      ? '30rem'
                      : this.columnDefs.length === 2
                        ? '22rem'
                        : '100%'
        } else {
          this.modalWidth = '70rem'
          this.padding = '0px !important'
        }
      }
    },
  },
}
